import request from '@/utils/request'

export function getPopupMessage() {
  return request.get('/message/popup')
}

export function listMessages(limit = 50) {
  return request.get('/message/list', { params: { limit } })
}

export function getUnreadMessageCount() {
  return request.get('/message/unread-count')
}

export function readMessage(messageId) {
  return request.put(`/message/${messageId}/read`)
}
